'use client';

import { JobOffersFilterContent } from './filter/job-offers-filter-content';

export const JobOffersFilterLeft = () => {
  return (
    <div className="flex flex-col gap-6 rounded-lg bg-[#F3F3F3] p-6">
      <JobOffersFilterContent />
    </div>
  );
};
